import { GlobalGroupCode } from '@orbis-systems/orbis-api-middleware';
import { createAction } from '@reduxjs/toolkit';

export const setGlobalIndustryName = createAction<string>('InsightsSetGlobalIndustryName');

export const setGlobalGroupCode = createAction<GlobalGroupCode>('InsightsSetGlobalGroupCode');

export const setEtfSymbol = createAction<string>('InsightsSetEtfSymbol');
